import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useChat } from '../ChatProvider';

const ChatPrivacyModal = ({ show, onHide, onAccept }) => {
  const { acceptPrivacy } = useChat();

  const handleAccept = () => {
    acceptPrivacy();
    onAccept?.();
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16, fontWeight: 600 }}>
          Quy định nhóm trao đổi học tập
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ lineHeight: 1.8, fontSize: 14 }}>
        <p>
          Nhóm chat này được tạo ra nhằm mục đích{' '}
          <strong>trao đổi học tập</strong> giữa học viên và giáo viên.
        </p>
        <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
          <li>
            <strong>Không chia sẻ thông tin cá nhân</strong> như số CMND/CCCD,
            mật khẩu, thông tin tài khoản trong nhóm.
          </li>
          <li>
            Các vấn đề về <strong>kỹ thuật, tài khoản, báo lỗi hệ thống</strong>{' '}
            vui lòng chuyển sang tab <strong>Kỹ thuật</strong> để nhắn tin
            trực tiếp với kỹ thuật viên.
          </li>
          <li>
            Vui lòng <strong>trao đổi lịch sự, tôn trọng</strong> mọi người
            trong nhóm.
          </li>
        </ul>
        <p style={{ margin: 0, color: '#64748b', fontSize: 13 }}>
          Bằng cách nhấn "Đồng ý", bạn xác nhận đã đọc và hiểu các quy định
          trên.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' size='sm' onClick={onHide}>
          Đóng
        </Button>
        <Button variant='primary' size='sm' onClick={handleAccept}>
          Đồng ý
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChatPrivacyModal;
